import React from "react";
import "../../../css/components/Services.css";
import legacy from "../../../assets/images/YourLegacy.jpeg"; // Replace with actual image paths
import future from "../../../assets/images/YourFuture.jpeg"; // Replace with actual image paths
import home from "../../../assets/images/YourHome.jpeg"; // Replace with actual image paths
import recovery from "../../../assets/images/YourRecovery.jpeg";
import lifestyle from "../../../assets/images/YourLifestyle.jpeg";
import plan from "../../../assets/images/ThePlan.jpeg";
import TertiaryButton from "../../components/buttons/TertiaryButton";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import SecondaryButton from "../../components/buttons/SecondaryButton";
import { useNavigate } from "react-router-dom";

const services = [
  {
    title: "Your Legacy",
    image: legacy,
    description:
      "What do you leave behind? Be sure that your legacy is one of provision and security for your loved ones.",
  },
  {
    title: "Your Future",
    image: future,
    description:
      "We teach you how to make the best from your savings and investment, whatever amount.",
  },
  {
    title: "Your Home",
    image: home,
    description:
      "More than a mortgage, we use True Cost analysis to go beyond the headline rate.",
  },
  {
    title: "Your Recovery",
    image: recovery,
    description:
      "How do you recover? How do you access the best treatments available? Don’t rely on the state.",
  },
  {
    title: "Your Lifestyle",
    image: lifestyle,
    description:
      "The mortgage and rent need paying, as do bills and living costs. Don't be forced to rely on the state.",
  },
  {
    title: "The Plan",
    image: plan,
    description:
      "Providing you with a clear, adaptable, and meaningful Plan for your future.",
  },
];

const Services = () => {
  const navigate = useNavigate();
  return (
    <section className="services-section">
      <div className="nav-bold secondary">What we do</div>
      <h2 className="primary">Real Advice. Real Outcomes.</h2>
      <div className="services-grid">
        {services.map((service, idx) => (
          <div
            className="service-card"
            key={idx}
            style={{
              backgroundImage: `url(${service.image})`,
            }}
          >
            <div className="service-content">
              <h2>
                <span className="first-word">{service.title.split(" ")[0]}</span>
              </h2>
              <h2 className="secondary italic">
                <span className="second-word">{service.title.split(" ")[1]}</span>
              </h2>
              <div className="service-hover-details">
                <p className="content">{service.description}</p>
                <SecondaryButton text="Start your journey" onClick={() => {
                  navigate("/#contact");
                }} />
              </div>
              <div className="find-out-more-area">
                <TertiaryButton
                  color="grey"
                  children={
                    <div className="subtitle uppercase secondary grey">
                      Find out more
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;
